import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, timer} from "rxjs";
import {takeUntil} from 'rxjs/operators';
import {CampaignEventsService} from "../booking-flow/services/campaign-events.service";

@Component({
    selector: 'app-ym-redirect',
    templateUrl: './ym-redirect.component.html',
    styleUrls: ['./ym-redirect.component.scss']
})
export class YmRedirectComponent implements OnInit, OnDestroy {
    counter: number;
    private readonly TOTAL_SECONDS = 20;
    private onDestroy$ = new Subject<void>();

    constructor(private campaignEventsService: CampaignEventsService) {}

    ngOnInit(): void {
        timer(0, 1000).pipe(takeUntil(this.onDestroy$)).subscribe({
            next: t => {
                this.counter = this.TOTAL_SECONDS - t;
                if (this.counter === 0) {
                    this.navigate();
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    navigate(): void {
        let params: string = this.campaignEventsService.utmParams();
        window.location.href = "https://wrench.com/book?" + params;
    }
}
